import { ImgHash, ImgEdge } from "./interfaces"

export const hashImages = (images: any) => {
  return images.edges.reduce((map: ImgHash, obj: ImgEdge) => {
    map[obj.node.name] = obj.node.childImageSharp
    return map
  }, {})
}
